"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTripTransportInput = exports.InternalTransport = exports.InternalLocation = exports.InternalPickupPoint = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const point_input_1 = require("../../commons/input/point.input");
class InternalPickupPoint {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "internalDescription", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "passengerText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "passengerEnglishText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "driverText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "driverEnglishText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "passengerSignText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "passengerEnglishSignText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "driverSignText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalPickupPoint.prototype, "driverEnglishSignText", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => point_input_1.PointInput),
    __metadata("design:type", point_input_1.PointInput)
], InternalPickupPoint.prototype, "point", void 0);
exports.InternalPickupPoint = InternalPickupPoint;
class InternalLocation {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InternalLocation.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalLocation.prototype, "iata", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => point_input_1.PointInput),
    __metadata("design:type", point_input_1.PointInput)
], InternalLocation.prototype, "position", void 0);
exports.InternalLocation = InternalLocation;
class InternalTransport {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalTransport.prototype, "transportCarrier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InternalTransport.prototype, "transportNumber", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InternalTransport.prototype, "scheduledDeparture", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], InternalTransport.prototype, "scheduledArrival", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], InternalTransport.prototype, "arrivalTerminal", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InternalLocation),
    __metadata("design:type", InternalLocation)
], InternalTransport.prototype, "arrival", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InternalLocation),
    __metadata("design:type", InternalLocation)
], InternalTransport.prototype, "departure", void 0);
exports.InternalTransport = InternalTransport;
class UpdateTripTransportInput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InternalTransport),
    __metadata("design:type", InternalTransport)
], UpdateTripTransportInput.prototype, "transport", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InternalPickupPoint),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", InternalPickupPoint)
], UpdateTripTransportInput.prototype, "pickupPoint", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UpdateTripTransportInput.prototype, "delayToKeep", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTripTransportInput.prototype, "newAddress", void 0);
exports.UpdateTripTransportInput = UpdateTripTransportInput;
